export default __webpack_public_path__ + "static/media/photo_Louis.5e273d0b.jfif";